module.exports = __webpack_public_path__ + "media/images/icon-ddd0157638452359e90c910b2e0a2d27.png";